module.exports = __webpack_public_path__ + "static/img/drops.568ab19c.png";